import React, { useState, useEffect } from "react"
import { getInitials } from "trux"
import { useSelector } from "react-redux"
import {
    Element,
    Row,
    Label,
    Button,
    Column,
    Icon,
    DropdownMenu,
    Link,
    Chip,
    Color,
    Avatar,
    isSmallMobileScreen,
    useToken,
} from "trux"
import { Page } from "../Navigation"
import { webApi } from "../../lib/WebApi"
import { useGetUserRelationsQuery } from "../../generated/graphql"

import "./Family.css"
export const Family = (props) => {
    const token = useToken("Family")
    const user_id = token?.user_id
    const tokenReady = token != null

    const { data: relations } = useGetUserRelationsQuery({
        variables: {
            to_user_id: token?.user_id,
            token: token,
            include_self: true,
        },
        skip: !tokenReady,
    })
    const userRelations = relations ? relations.userRelations : null
    console.log("userRelations", userRelations)

    const sortedRelations = [...(userRelations ? userRelations : [])].sort(
        (a, b) => a.user.first_name.localeCompare(b.user.first_name)
    )
    const prioritizedRelations = user_id
        ? sortedRelations.sort((a, b) => {
              return a.user_id == user_id ? -1 : b.user_id !== user_id ? 1 : 0
          })
        : sortedRelations

    let familyRows = prioritizedRelations.map((person) => {
        return (
            <FamilyRow
                key={person.id}
                relation={person}
                history={props.history}
                match={props.match}
            />
        )
    })

    const onFamilyInviteClick = (e) => {
        var teamId = props.match.params.team
        props.history.push(`/${teamId}/family/invite`)
    }

    return (
        <Element className="page">
            <Page teamId={props.match.params.team}>
                <Element marginBottom="6">
                    <Element padding="8">
                        <Column center>
                            <Label
                                type={Label.Type.Heading2}
                                content="My family"
                                className="family-page-title"
                                marginBottom="2"
                            />
                            <Label
                                type={Label.Type.Body}
                                content="Family get all your Trace video, and have access to edit everything in your account."
                                className="team-title"
                                marginBottom="4"
                            />

                            <Button
                                center
                                content="Invite a family member"
                                className="button"
                                onClick={onFamilyInviteClick}
                            />
                        </Column>
                    </Element>
                    <Column className="table-column">
                        <Element className="tr table-header">
                            <Element className={"td name"}>Name</Element>
                            <Element className={"td email"}>Email</Element>
                            <Element className={"td phone"}>Phone</Element>
                            <Element className={"td role"}>Role</Element>
                            <Element className={"td more"}></Element>
                        </Element>
                        <Element>{familyRows}</Element>
                    </Column>
                </Element>
            </Page>
            <Element className="footer">
                <Label type={Label.Type.SmallBody}>
                    Questions? Check out our <Link>Support Center</Link> for
                    answers to FAQs or contact us at q@traceup.com
                </Label>
            </Element>
        </Element>
    )
}

export const FamilyRow = ({ key, relation, history, match }) => {
    const relationUserId = relation.user_id
    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1)
    }

    const fullName = relation
        ? relation.user.first_name + " " + relation.user.last_name + " "
        : "-"
    const firstName = relation ? relation.user.first_name : "-"
    const initials = relation
        ? getInitials(relation.user.first_name, relation.user.last_name)
        : "-"
    console.log("initials", getInitials)
    let relationString = relation
        ? relation.relation === "self"
            ? "me"
            : relation.relation
        : "-"
    if (relationString === "spouse") {
        relationString = "family"
    }
    if (relationString === "child") {
        relationString = "player"
    }
    const relationship = relation
        ? `${capitalizeFirstLetter(relationString)}`
        : ""
    const email = relation ? relation.user.email : ""
    const phone = "111-222-3333"

    let options = []

    options = [
        {
            title: (
                <Row>
                    <Icon type={Icon.Type.Edit} />
                    <Label marginLeft="2" content="Edit family member" />
                </Row>
            ),
            value: "edit",
        },
        {
            title: (
                <Row>
                    <Icon type={Icon.Type.Leave} />{" "}
                    <Label
                        marginLeft="2"
                        content={`Go to ${firstName}'s Trace iD`}
                    />
                </Row>
            ),
            value: "trace",
        },
        {
            title: (
                <Row>
                    <Icon type={Icon.Type.Close} />
                    <Label marginLeft="2" content="Remove family member" />
                </Row>
            ),
            value: "remove",
        },
    ]

    const onChange = (e, val) => {
        var teamId = match.params.team
        if (val === "remove") {
            if (e) {
                e.preventDefault()
            }
            history.push(`/${teamId}/family/${relationUserId}/remove`)
        } else {
            if (e) {
                e.preventDefault()
            }
            history.push(`/${teamId}/family/${relationUserId}/edit`)
        }
    }
    if (isSmallMobileScreen()) {
        return (
            <DropdownMenu
                title="TracerItem"
                className="member-dropdown"
                onChange={onChange}
                options={options}
                menuDirection={"bottom"}
                menuPortal={"#modal-root"}
                buttonHeight={"50"}
                offsetAxisY={8}
                buttonWidth={`${"100%"}`}
                button={
                    <Element className="tr contents">
                        <Element className="td avatar">
                            <Avatar
                                initials={initials}
                                fullName={fullName}
                                marginRight="2"
                            />
                        </Element>
                        <Element className="td name">
                            <Label type={Label.Type.Body} bold>
                                {fullName}
                            </Label>
                            <Label type={Label.Type.SmallBody}>{email}</Label>
                        </Element>
                        <Element className="td role">
                            {relationString === "me" && (
                                <Chip content="Me" className="me-chip" />
                            )}
                            {relationString !== "me" && (
                                <Label type={Label.Type.Body}>
                                    {relationship}
                                </Label>
                            )}
                        </Element>
                    </Element>
                }
            ></DropdownMenu>
        )
    } else {
        return (
            <Element className="tr contents">
                <Element className="td name">
                    <Row alignItems="center">
                        <Avatar
                            initials={initials}
                            fullName={fullName}
                            marginRight="2"
                        />
                        <Label type={Label.Type.Body} bold>
                            {fullName}
                        </Label>
                    </Row>
                </Element>
                <Element className="td email">
                    <Label type={Label.Type.Body}>{email}</Label>
                </Element>
                <Element className="td phone">
                    <Label type={Label.Type.Body}>{phone}</Label>
                </Element>
                <Element className="td role">
                    {relationString === "me" && (
                        <Chip content="Me" className="me-chip" />
                    )}
                    {relationString !== "me" && (
                        <Label type={Label.Type.Body}>{relationship}</Label>
                    )}
                </Element>
                <Element className="td more">
                    <DropdownMenu
                        title="TracerItem"
                        className="member-dropdown"
                        onChange={onChange}
                        options={options}
                        menuDirection={"bottom"}
                        menuPortal={"#modal-root"}
                        buttonHeight={"50"}
                        offsetAxisY={8}
                        buttonWidth={`${"100%"}`}
                        button={<Icon type={Icon.Type.More} />}
                    ></DropdownMenu>
                </Element>
            </Element>
        )
    }
}
